import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from "../Tabs/Tabs";
import FeeBuilderTabContent from "./FeeBuilderTabContent";
import FeeBuilderUpdateFolioItems from "./tabs/FeeBuilderUpdateFolioItems";
import ReactPortalsRoot from "../ReactPortalsRoot/ReactPortalsRoot";
import ModalButtons from "../ModalButtons/ModalButtons";
import ModalWarning from "../ModalWarning/ModalWarning";
import FeeBuilderErrors from "./FeeBuilderErrors";
import { isSameDay, parseISO } from "date-fns";

export default class FeeBuilder extends React.Component {
  constructor(props) {
    super(props);

    var unit;
    if (this.props.tax_fee_unit) {

      if (this.props.tax_fee_unit.ru_id == "1") {
        unit = "room_per_stay"
      } else if (this.props.tax_fee_unit.ru_id == "2") {
        unit = "room_per_day"
      } else if (this.props.tax_fee_unit.ru_id == "5") {
        unit = "guest_per_stay"
      } else if (this.props.tax_fee_unit.ru_id == "6") {
        unit = "guest_per_day"
      } else {
        unit = null
      }
    } else {
      unit = null
    }

    var taxes;
    this.props.taxes && this.props.taxes.length > 0
      ? (taxes = this.props.taxes.map((tax) => tax.id))
      : (taxes = []);

    var products;
    this.props.products && this.props.products.length > 0
      ? (products = this.props.products.map((product) => product.id))
      : (products = []);

    var guest_types;
    this.props.guest_types && this.props.guest_types.length > 0
      ? (guest_types = this.props.guest_types.map(
          (guest_type) => guest_type.id
        ))
      : (guest_types = []);

    var cancellation_rules;
    this.props.cancellation_rules && this.props.cancellation_rules.length > 0
      ? (cancellation_rules = this.props.cancellation_rules.map(
          (cancellation_rule) => cancellation_rule.id
        ))
      : (cancellation_rules = []);

    var rates;
    this.props.rates && this.props.rates.length > 0
      ? (rates = this.props.rates.map((rate) => rate.id))
      : (rates = []);

    var fees;
    this.props.fees && this.props.fees.length > 0
      ? (fees = this.props.fees.map((fee) => fee.id))
      : (fees = []);

    this.state = {
      active_tab: "general",
      errors: this.props.errors ? this.props.errors : {},
      id: this.props.id,
      code: this.props.code || null,
      name: this.props.name || null,
      percentage: this.props.percentage || null,
      amount: this.props.amount || null,
      unit: unit,
      start_date: this.props.start_date
        ? parseISO(this.props.start_date)
        : null,
      end_date: this.props.end_date ? parseISO(this.props.end_date) : null,
      excludedFolioItems: [],
      status: this.props.status || "disabled",
      loading: false,
      taxes: taxes,
      fees: fees,
      products: products,
      guest_type_id: guest_types && guest_types.length > 0 ? guest_types[0] : null,
      guests_included: this.props.guests_included || 0,
      cancellation_rules: cancellation_rules,
      rates: rates,
      select_status:
        this.props.amount > 0 || this.props.unit != null ? "disabled" : null,
      updated_at: this.props.updated_at,
      updateFolioItems: false,
      props_taxes: taxes,
      props_cancellation_rules: cancellation_rules,
      props_guest_types: guest_types,
      props_rates: rates,
      props_products: products,
      tax_fee_type_id: this.props.tax_fee_type_id,
      displayWarningModal: false,
      textConfirmation: false,
      doubleTextConfirmation: false,
      new_record: this.props.new_record,
      calculate_by_guest_type: this.props.calculate_by_guest_type ? this.props.calculate_by_guest_type : false,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangePercentage = this.onChangePercentage.bind(this);
    this.onChangeAmount = this.onChangeAmount.bind(this);
    this.onChangeUnit = this.onChangeUnit.bind(this);
    this.onChangeTaxes = this.onChangeTaxes.bind(this);
    this.onChangeProducts = this.onChangeProducts.bind(this);
    this.onChangeGuestType = this.onChangeGuestType.bind(this);
    this.excludeFolioItems = this.excludeFolioItems.bind(this);
    this.onChangeRates = this.onChangeRates.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onUpdateFolioItems = this.onUpdateFolioItems.bind(this);
    this.onChangeUpdateFolioItems = this.onChangeUpdateFolioItems.bind(this);
    this.onChangeFees = this.onChangeFees.bind(this);
    this.onTextConfirmation = this.onTextConfirmation.bind(this)
    this.onDoubleTextConfirmation = this.onDoubleTextConfirmation.bind(this)
    this.onChangeCalculateByGuestType = this.onChangeCalculateByGuestType.bind(this)
  }

  render() {
    var self = this;
    
    if (
      (this.props.tax &&
        !this.props.new_record &&
        this.props.status == "disabled" &&
        this.state.status == "disabled") ||
      (this.props.new_record && this.state.status == "disabled") ||
      !this.props.tax
    ) {
      var buttons = [
        {
          name: I18n.t("cancel"),
          html_attributes: ['data-dismiss="modal"'],
        },
        {
          name: I18n.t("submit"),
          button_classes: ["primary"],
          onClick: function (e) {
            e.stopPropagation();
            e.preventDefault();

            self.onSave();
          },
        },
      ];
    } else {
      if (
        this.props.status != this.state.status ||
        this.props.percentage != this.state.percentage ||
        this.props.amount != this.state.amount ||
        this.props.unit != this.state.unit ||
        !isSameDay(
          new Date(this.props.start_date),
          new Date(this.state.start_date)
        ) ||
        !isSameDay(
          new Date(this.props.end_date),
          new Date(this.state.end_date)
        ) ||
        this.state.props_taxes != this.state.taxes ||
        this.state.props_products != this.state.products ||
        this.state.props_cancellation_rules != this.state.cancellation_rules ||
        this.state.props_guest_types != this.state.guest_types ||
        this.state.props_rates != this.state.rates
      ) {
        var buttons = [
          {
            name: I18n.t("cancel"),
            html_attributes: ['data-dismiss="modal"'],
          },
          {
            name: I18n.t("submit"),
            button_classes: ["primary"],
            onClick: (e) => {
              e.stopPropagation();
              e.preventDefault();
              this.setState({
                displayWarningModal: true,
              });
            },
          },
        ];


      } else if (this.state.displayWarningModal) {
        buttons = [
          {
            name: I18n.t('cancel'),
            html_attributes: [
              'data-dismiss="modal"'
            ]
          },
          {
            name: I18n.t('submit'),
            button_classes: ['primary', this.state.textConfirmation == true && this.state.doubleTextConfirmation == true ? null : ' disabled'],
            onClick: (e) => {
              this.submit();
              return false;
            },
          },

        ];
      } else {
        var buttons = [
          {
            name: I18n.t("cancel"),
            html_attributes: ['data-dismiss="modal"'],
          },
          {
            name: I18n.t("submit"),
            button_classes: ["primary"],
            onClick: function (e) {
              e.stopPropagation();
              e.preventDefault();

              self.onSave();
            },
          },
        ];
      }
    }
    return (
      <div className="fee-builder">
        <Tabs
          tabs={this.tabs()}
          displayErrorMessage={
            FeeBuilderErrors.generalErrors(this.state.errors).length
          }
        />
        {!this.state.displayWarningModal ?<ModalButtons loading={this.state.loading} buttons={buttons} /> : null}

        <div className="panel panel-form">
          <FeeBuilderTabContent
            {...this.state}
            tax_task_logs_data_table_path={this.props.tax_task_logs_data_table_path}
            fee_task_logs_data_table_path={this.props.fee_task_logs_data_table_path}
            tax={this.props.tax}
            all_taxes={this.props.all_taxes}
            all_rates={this.props.all_rates}
            all_fees={this.props.all_fees}
            all_products={this.props.all_products}
            all_cancellation_rules={this.props.all_cancellation_rules}
            all_guest_types={this.props.all_guest_types}
            all_tax_fee_types={this.props.all_tax_fee_types}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
            onChange={this.onChange}
            onChangePercentage={this.onChangePercentage}
            onChangeAmount={this.onChangeAmount}
            onChangeUnit={this.onChangeUnit}
            onChangeProducts={this.onChangeProducts}
            onChangeRates={this.onChangeRates}
            onChangeGuestType={this.onChangeGuestType}
            excludeFolioItems={this.excludeFolioItems}
            onChangeFees={this.onChangeFees}
            onChangeTaxes={this.onChangeTaxes}
            onChangeCalculateByGuestType={this.onChangeCalculateByGuestType}
          />
          <LoadingSpinner show={this.state.loading} />
        </div>
        {this.state.displayWarningModal ? (
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t("update_folio_items")}
                body={this.onUpdateFolioItems(buttons)}
                CancelSubmit
                onSubmit={this.onSave}
                onCancel={() => this.setState({ displayWarningModal: false })}
                disabled_buttons={this.state.textConfirmation  && this.state.doubleTextConfirmation ? false : true}
              />
            ]}
            wrapperClassNames="ModalWarningWrapper"
          />
        ) : null}
      </div>
    );
  }

  setParams() {
    if (this.props.tax) {
      return {
        tax: {
          code: this.state.code,
          name: this.state.name,
          start_date: this.state.start_date,
          end_date: this.state.end_date,
          amount: this.state.amount,
          percentage: this.state.percentage ? this.state.percentage : null,
          unit: this.state.unit,
          status: this.state.status,
          guests_included: this.state.guests_included,
          tax_fee_type_id: this.state.tax_fee_type_id,
          updated_at: this.props.updated_at,
        },
        fee_ids: this.state.fees,
        update_folio_items: this.state.updateFolioItems == "yes" ? true : false,
        product_ids: this.state.products,
        rate_ids: this.state.rates,
        cancellation_rule_ids: this.state.cancellation_rules,
        excluded_folio_item_ids: this.state.excludedFolioItems,
      };
    } else {
      return {
        fee: {
          code: this.state.code,
          name: this.state.name,
          start_date: this.state.start_date,
          end_date: this.state.end_date,
          amount: this.state.amount,
          percentage: this.state.percentage,
          unit: this.state.unit,
          guests_included: this.state.guests_included,
          status: this.state.status,
          tax_fee_type_id: this.state.tax_fee_type_id,
          calculate_by_guest_type: this.state.calculate_by_guest_type,
          updated_at: this.props.updated_at,
        },
        tax_ids: this.state.taxes,
        product_ids: this.state.products,
        update_folio_items: this.state.updateFolioItems,
        rate_ids: this.state.rates,
        cancellation_rule_ids: this.state.cancellation_rules,
        guest_type_ids: this.state.guest_type_id ? new Array(this.state.guest_type_id) : null,
        excluded_folio_item_ids: this.state.excludedFolioItems,
      };
    }
  }

  onSave() {
    var self = this;
    this.setState({ loading: true });
    var params = this.setParams();

    $.ajax({
      type: this.props.new_record ? "POST" : "PUT",
      url: this.props.form_action,
      data: params,
    }).done((data) => {
      if (data.errors && Object.keys(data.errors).length) {
        this.setState({
          loading: false,
          errors: data.errors,
          displayWarningModal: false,
        });
      } else {
        this.setState({ loading: false });
        if (parent && parent.refresh_data) {
          if (self.props.new_record == true) {
            self.props.tax
              ? parent.refresh_data(I18n.t("tax_created_successfully"))
              : parent.refresh_data(I18n.t("fee_created_successfully"));
          } else {
            self.props.tax
              ? parent.refresh_data(I18n.t("tax_saved_successfully"))
              : parent.refresh_data(I18n.t("fee_saved_successfully"));
          }
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    });
  }

  onChange(event) {
    if (
      event &&
      event.target &&
      event.target.name &&
      typeof event.target.value != "undefined"
    ) {
      var newState = {};
      newState[event.target.name] = event.target.value;
      this.setState(newState);
    }
  }

  onChangeCalculateByGuestType(event) {
    this.setState({
      calculate_by_guest_type: event.target.checked,
      guest_types: event.target.checked ? this.state.guest_types : [],
    })
  }

  onChangeTaxes(selected_taxes) {
    this.setState({
      taxes: selected_taxes,
    });
  }

  onChangeProducts(selected_products) {
    this.setState({
      products: selected_products,
    });
  }

  onChangeGuestType(e) {
    this.setState({
      guest_type_id: e.target.value,
    });
  }

  excludeFolioItems(data) {
    excludedItems = this.state.excludedFolioItems.slice(0);

    data.forEach((item) => excludedItems.push(item));
    this.setState({
      excludedFolioItems: excludedItems,
    });
  }

  onChangeRates(selected_rates) {
    this.setState({
      rates: selected_rates,
    });
  }

  onChangeFees(selected_fees) {
    this.setState({
      fees: selected_fees,
    });
  }

  onChangePercentage(value) {
    if (value || value === 0) {
      var state = this.state;
      state.percentage = value;
      state.amount = null;
      state.unit = null;
      state.select_status = null;
      this.setState(state);
    }
  }

  onChangeAmount(value) {
    if (value) {
      var state = this.state;
      state.amount = value;
      state.percentage = null;
      state.select_status = "disabled";
      state.cancellation_rules = [];
      state.products = [];
      state.fees = [];
      this.setState(state);
    }
  }

  onChangeUnit(value) {
    if (value && value == "room_per_day" || value && value == "room_per_stay") {
      var state = this.state;
      state.unit = value;
      state.percentage = null;
      state.select_status = "disabled";
      state.cancellation_rules = [];
      state.products = [];
      state.guest_types = [];
      state.fees = [];
      this.setState(state);
    } else if (value) {
      var state = this.state;
      state.unit = value;
      state.percentage = null;
      state.select_status = "disabled";
      state.cancellation_rules = [];
      state.products = [];
      state.fees = [];
      this.setState(state);
    }
  }

  onChangeApplyToProducts(change) {
    this.setState({
      apply_to_products: change,
    });
  }

  onChangeActiveTab(name) {
    this.setState({
      active_tab: name,
    });
  }

  onTextConfirmation(textConfirmation) {
    this.setState({ textConfirmation: textConfirmation });
  }

  onDoubleTextConfirmation(doubleConfirmation) {
    this.setState({ doubleTextConfirmation: doubleConfirmation });
  }

  onChangeUpdateFolioItems(e) {
    this.setState({ updateFolioItems: e.target.value });
  }

  onUpdateFolioItems(buttons) {
    return (
      <FeeBuilderUpdateFolioItems
        submit={this.onSave}
        showDoubleConfirmation={true}
        environment={this.props.environment}
        onDoubleTextConfirmation={this.onDoubleTextConfirmation}
        onTextConfirmation={this.onTextConfirmation}
        updateFolioItems={this.state.updateFolioItems}
        onChangeUpdateFolioItems={this.onChangeUpdateFolioItems}
       />
    );
  }

  tabs() {
    let guest = false

    if (this.state.unit == "guest_per_stay" || this.state.unit == "guest_per_day") {
      guest = true
    }

    if (this.props.new_record && this.props.tax && guest ){
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FeeBuilderErrors.generalErrors(this.state.errors)
              .length,
          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("products"),
            targetName: "products",
            classes: this.state.active_tab === "products" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("fees"),
            targetName: "fees",
            classes: this.state.active_tab === "fees" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )
    } else if (this.props.new_record && this.props.tax) {
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FeeBuilderErrors.generalErrors(this.state.errors)
              .length,
          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("products"),
            targetName: "products",
            classes: this.state.active_tab === "products" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("fees"),
            targetName: "fees",
            classes: this.state.active_tab === "fees" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )
    } else if (this.props.tax && !this.props.new_record && guest) {
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FeeBuilderErrors.generalErrors(this.state.errors)
              .length,
          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("products"),
            targetName: "products",
            classes: this.state.active_tab === "products" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )


    } else if (this.props.tax) {
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FeeBuilderErrors.generalErrors(this.state.errors)
              .length,
          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("products"),
            targetName: "products",
            classes: this.state.active_tab === "products" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("fees"),
            targetName: "fees",
            classes: this.state.active_tab === "fees" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )
    } else if (guest && this.state.calculate_by_guest_type) {
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FeeBuilderErrors.generalErrors(this.state.errors)
              .length,
          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },

          {
            tabName: I18n.t("taxes"),
            targetName: "taxes",
            classes: this.state.active_tab === "taxes" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("guest_types"),
            targetName: "guest_types",
            classes: this.state.active_tab === "guest_types" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FeeBuilderErrors.guestTypeErrors(this.state.errors)
              .length,
          },
        ]
      )
    } else {
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: FeeBuilderErrors.generalErrors(this.state.errors)
              .length,
          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
 
          {
            tabName: I18n.t("taxes"),
            targetName: "taxes",
            classes: this.state.active_tab === "taxes" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )
    }


  }
}
